export default "::selection{background-color:var(--selection-color)}";